<div class="text-center">
    <h4 style="margin-top: 100px;">Oops! Looks like the server is not online.</h4>
</div>